// Usage:
//const result1 = new Str('1231231.32423423').toString(5);
import { formatLocaleNumber, parseLocaleNumber } from '../lib/number-locale';

class Num {
    constructor(num) {
        this.number = num;
    }

    toString(decimalPlaces = 2) {
        const numFloat = parseLocaleNumber(this.number);

        if (isNaN(numFloat)) {
            return '';
        }

        return formatLocaleNumber(numFloat, decimalPlaces);
    }
}

export default Num;
